export default (theAddon) => {
    
    let itemPrice = parseFloat(theAddon.price);
    itemPrice *= cartItem.quantity;
    
    return itemPrice.toFixed(2);
}